'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserPersonalToken } from '../../Entities/User/UserPersonalToken';
import { UserPersonalTokenCollection } from '../../Collections/User/UserPersonalTokenCollection';

export class UserPersonalTokenRepository extends CoreRepository {
  public createUserPersonalToken(userId: number, appReference: string, payload: object = {}) {
    return this.webAPI.createUserPersonalToken(userId, appReference, payload).then((response) => {
      const item = new UserPersonalToken();
      item.hydrate(response);

      return item;
    });
  }

  public getUserPersonalToken(userId: number, appReference: string, options: object = {}) {
    return this.webAPI.getUserPersonalToken(userId, appReference, options).then((response) => {
      return response;
    });
  }

  public deleteUserPersonalToken(userId: number, appReference: string) {
    return this.webAPI.deleteUserPersonalToken(userId, appReference).then((response) => {
      return response;
    });
  }

  public updateUserPersonalToken(
    userId: number,
    appReference: string,
    personalTokenId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .updateUserPersonalToken(userId, appReference, personalTokenId, payload)
      .then((response) => {
        return response;
      });
  }
}
